import React from "react";
import { useLocation } from "react-router-dom";
import { getHead, NOT_FOUND_HEAD, ADMIN_HEAD, SITE_NAME } from "@/content/seo";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content || "");
};

const setLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

const LD_ID = "lanvaus-jsonld";

/**
 * Keeps the head correct during client-side navigation. The authoritative tags
 * for crawlers are server-rendered by the Node server (backend/seo/render.js);
 * this mirrors them so in-app route changes stay accurate.
 */
export const applyHead = (head) => {
  document.title = head.title;
  document.documentElement.lang = "en-IN";
  setMeta("name", "description", head.description);
  setMeta("name", "keywords", head.keywords);
  setMeta("name", "robots", head.robots);
  setMeta("name", "geo.region", "IN");
  setMeta("name", "geo.placename", "Hyderabad, Telangana");
  setLink("canonical", head.canonical);

  setMeta("property", "og:type", head.ogType);
  setMeta("property", "og:site_name", SITE_NAME);
  setMeta("property", "og:title", head.title);
  setMeta("property", "og:description", head.description);
  setMeta("property", "og:url", head.canonical);
  setMeta("property", "og:image", head.ogImage);
  setMeta("property", "og:locale", "en_IN");

  setMeta("name", "twitter:card", "summary_large_image");
  setMeta("name", "twitter:title", head.title);
  setMeta("name", "twitter:description", head.description);
  setMeta("name", "twitter:image", head.ogImage);

  document.getElementById(LD_ID)?.remove();
  if (head.jsonLd) {
    const script = document.createElement("script");
    script.id = LD_ID;
    script.type = "application/ld+json";
    script.text = JSON.stringify(head.jsonLd);
    document.head.appendChild(script);
  }
};

export const Seo = () => {
  const { pathname } = useLocation();

  React.useEffect(() => {
    // Article pages set their own head once the post is loaded.
    if (pathname.startsWith("/insights/")) return;
    if (pathname.startsWith("/admin")) {
      applyHead(ADMIN_HEAD);
      return;
    }
    applyHead(getHead(pathname) || NOT_FOUND_HEAD);
  }, [pathname]);

  return null;
};
